import './Events.css';
import saladImg from '../../assets/images/Salad_Catering.jpg';
import kellnerinImg from '../../assets/images/Kellnerin.jpg';
import cateringPdf from '../../assets/pdfs/Presentation_Catering.pdf';

function Events() {
  return (
    <section id="events" className="events">
      <div className="events__inner">
        <div className="events__content">
          <span className="events__label">Events &amp; Veranstaltungen</span>
          <h2 className="events__title">
            Unvergessliche<br />Momente schaffen
          </h2>
          <div className="events__divider" />
          <p className="events__text">
            Das Rocaille ist der ideale Ort für private Dinner, Firmenevents,
            Geburtstage und besondere Anlässe. Unser erfahrenes Team gestaltet
            Ihren Abend nach Ihren Wünschen – von der Menüplanung bis zum
            stimmungsvollen Ambiente.
          </p>
          <div className="events__actions">
            <a href="#contact" className="events__btn events__btn--primary">
              Anfrage stellen
            </a>
            <a href={cateringPdf} target="_blank" rel="noopener noreferrer" className="events__btn events__btn--secondary">
              Mehr Infos
            </a>
          </div>
        </div>

        <div className="events__gallery">
          <div className="events__gallery-item">
            <img src={saladImg} alt="Catering – Kulinarik" className="events__gallery-img" />
          </div>
          <div className="events__gallery-item">
            <img src={kellnerinImg} alt="Events – Service & Atmosphäre" className="events__gallery-img" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Events;
